import { AddModalProps } from '../../types';
import { Button, HStack, Spacer, VStack } from '@chakra-ui/react';
import { Labeled } from '@partiu/ui/components/molecules/Labeled.tsx';
import { useForm } from 'react-hook-form';
import { Input } from '@partiu/ui/components/atoms/Input.tsx';
import { useCreateAgreementPromocodeBatchMutation } from '@partiu/api/dashboard/hooks.ts';
import { FaPlus } from 'react-icons/fa6';
import { toReadableDate } from '@partiu/ui/formatters.ts';
import { ICreateAgreementPromocodeBatch } from '@partiu/api/dashboard/types.ts';

export function PromocodeForm({ onClose, options }: AddModalProps<ICreateAgreementPromocodeBatch>) {
  const { register, handleSubmit, watch } = useForm({
    defaultValues: {
      name: '',
      tag: '',
      quantity: 10,
      validUntil: new Date(new Date().setDate(new Date().getDate() + 180)),
    },
  });
  const validUntil = watch('validUntil');
  const mutation = useCreateAgreementPromocodeBatchMutation(options);

  return (
    <form
      onSubmit={handleSubmit((data) =>
        mutation.mutate({
          name: data.name,
          quantity: data.quantity,
          validUntil: data.validUntil.toISOString(),
          tag: data.tag,
        })
      )}
    >
      <VStack spacing={5}>
        <Labeled label={'Nome'}>
          <Input register={register('name', { required: true })} />
        </Labeled>
        <Labeled label={'Quantidade'}>
          <Input type={'number'} register={register('quantity', { required: true, min: 1 })} />
        </Labeled>
        <Labeled label={'Tag'}>
          <Input register={register('tag', { required: false })} />
        </Labeled>
        <Labeled label={'Válido Até'} helpText={'Todo lote têm validade de 6 meses.'}>
          <Input disabled={true} value={toReadableDate(validUntil)} />
        </Labeled>
        <HStack width={'100%'}>
          <Spacer />
          <Button isLoading={mutation.isLoading} variant="ghost" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            leftIcon={<FaPlus />}
            isLoading={mutation.isLoading}
            type={'submit'}
            variant={'solid'}
            colorScheme={'green'}
          >
            Criar
          </Button>
        </HStack>
      </VStack>
    </form>
  );
}
